<div class="apply-con">
    <ul class="apply-nav">
        <li class="active">申请实习咨询师</li>
        <li>申请特约咨询师</li>
    </ul>
    <div class="apply-content">
        <div class="apply-content-item active" id="">
            <div style="height: 160px;text-align:center">
                <img style="height: 100%" src="../../../public/images/apply-angel.png">
            </div>
            <div class="about">
                <h3>关于实习咨询师<span id="angelRule" class="fr">咨询师详情说明</span>
                </h3>
                <ul class="about-des">
                    <li>“实习咨询师”是申请成为正式咨询师的预备阶段，只有符合条件的实习咨询师才有资格成一名优质的咨询师并为平台用户提供优质服务。</li>
                </ul>
                <ul class="about-feature">
                    <li>音色良好，有一定学识和谈资；</li>
                    <li>平台管理员认定综合素质良好；</li>
                    <li>没有作弊、严重违规或被用户严重投诉；</li>
                    <li>有一定闲余时间；</li>
                </ul>
            </div>
            <div class="claim">
                <h3>申请要求</h3>
                <table>
                    <tbody>
                        {{each ApplyData.RequireList item }}
                        {{if item.State}}
                        <tr>
                            <td>{{item.Title}}</td>
                            <td>{{item.CompleteRate}}</td>
                        </tr>
                        {{else}}
                        <tr class="active">
                            <td>{{item.Title}}</td>
                            <td>{{item.CompleteRate}}</td>
                        </tr>
                        {{/if}}
                        {{/each}}
                    </tbody>
                </table>
            </div>
            <div class="btn-wrap">
                <a class="apply-btn usable-btn">前往考米APP申请</a>
                <!-- {{if ApplyData.Rate < 100}} -->
                <!--资料不完善-->
                <!-- <a class="disable-btn">立即申请</a> -->
                <!-- {{else if ApplyData.Rate }} -->
                <!--资料已完善-->
                <!-- <a class="apply-btn usable-btn">立即申请</a> -->
                <!-- {{/if}} -->
                <!-- {{ if ApplyData.MessageID == -10335}} -->
                <!-- <a class="apply-btn reviewing-btn">审核中...</a> -->
                <!-- {{/if}} -->
            </div>
        </div>
        <div class="apply-content-item" id="">
            <div style="height: 160px;text-align:center">
                <img style="height: 100%" src="../../../public/images/apply-special.png">
            </div>
            <div class="about">
                <h3>关于特约咨询师</h3>
                <ul class="about-des">
                    <li>如果您声音条件特别优秀，或是在某些领域有专长和知名度的专家达人、红人名人（如艺术院校师生、知名博主、主播、歌手、艺人、模特、心理咨询师）等，欢迎以特约咨询师的身份入驻考米，通过考米平台特有的通话方式与粉丝互动（隐藏真实号码），保护隐私，收入丰厚。
                    </li>
                    <li>您通过资质审核后可设置比星级咨询师更高的接听资费，并将有机会获得考米平台提供的专属推荐位宣传资源，合作咨询。联系QQ：3039700970</li>
                </ul>
                <h3>申请要求</h3>
                <ul class="about-feature">
                    <li>声音条件特别优秀</li>
                    <li>某些领域的专家达人、红人名人</li>
                    <li>有一定的空闲时间</li>
                </ul>
                <h3>申请特约咨询师请联系考米小管家 </h3>
                <span style="color: #666">QQ：3039700970 </span>
            </div>

        </div>
    </div>
</div>



<div id="applyEntry-con">
    <div class="ui-dialog-title clearfix">
        <p class="mb5">申请咨询师</p>
        <div>请务必填写真实信息，错误信息将会影响您未来的收入与提现</div>
    </div>
    <div style="padding: 0 40px;">
        <form class="layui-form">
            <div class="form-data-item">
                <label class="form-label">真实姓名</label>
                <div class="form-block">
                    <input type="text" value="" id="applyRealName" placeholder="请填写真实姓名">
                </div>
            </div>
            <div class="form-data-item">
                <label class="form-label">身份证号</label>
                <div class="form-block">
                    <input type="text" value="" id="applyRealCode" placeholder="请输入身份证号码">
                </div>
            </div>
            <div class="form-data-item">
                <label class="form-label">所在地</label>
                <div class="form-block" style="width:130px">
                    <select name="applyprovince" lay-filter="applyprovince"></select>
                </div>
                <div class="form-block" style="width:130px;margin-left: 10px;">
                    <select name="applycity" lay-filter="applycity"></select>
                </div>
            </div>
            <div class="form-data-item">
                <label class="form-label">特长<span>不超过3项</span></label>
                <div class="labelList-con clearfix" id="specialtyList"
                    style="display: inline-block;vertical-align: middle;width: 300px">
                    {{each ApplyAngelSpecialtyList item}}
                    <span class="label fl mr10 mb10" data-id="{{item.TypeValue}}">{{item.TypeName}}</span>
                    {{/each}}
                </div>
            </div>
            <div class="form-data-item">
                <label class="form-label">申请理由</label>
                <div class="form-block" style="width: 410px">
                    <input type="text" value="" id="applyReason" placeholder="请输入申请理由">
                </div>
            </div>
            <div class="form-data-item">
                <label class="form-label">证件信息</label>
                <div class="idupoload-con clearfix" style="display: inline-block;vertical-align: middle;width: 410px">
                    <div class="fl" style="margin-right: 10px;">
                        <div id="idfront">
                            <i class="iconfont icon-add" style="font-size: 24px;color: #FF5379"></i>
                            <p>身份证正面照</p>
                        </div>
                    </div>
                    <div class="fl">
                        <div id="idback">
                            <i class="iconfont icon-add" style="font-size: 24px;color: #FF5379"></i>
                            <p>手持身份证素颜照</p>
                        </div>
                    </div>
                    <ul class="idupoload-tip">
                        <li>1.照片为JPG或PNG格式，确保文字、号码清晰可辨 </li>
                        <li>2.上传的证件照片只用作审核，考米承诺不会泄露您的信息，请您放心</li>
                    </ul>
                </div>
            </div>
        </form>
    </div>

    <div class="btn-wrap">
        <a class="btn-confirm" id="sub-btn">提交审核</a>
    </div>
</div>

<div id="closeWinking-con" style="display: none">
    <div class="qrcodeCon" style="padding: 100px 0;">
        <div id="qrcode">
            <div class="qrcode-item qrcode-item-1">
                <div class="qrcode-img"></div>
                <div class="qrcode-text">
                    <p class="title">扫码下载APP</p>
                </div>
            </div>
        </div>
    </div>
</div>